import userIcon from "assets/icons/userIcon-light.svg";
// import ImgWrapper from "components/global/ImgWrapper";
import PlatformPhoto from "components/global/PlatformPhoto";
import Spacer from "components/global/Spacer";
import UpgradeModal from "components/global/UpgradeModal";
import { socialIcons, supportedPlatforms } from "constants/post";
import { useCallback, useContext, useState } from "react";
import { connect } from "react-redux";
import { toggleModalVisibility } from "utils/utils";
import AddBrandModal from "./AddBrandModal";
import { Socials } from "../styles/PostStyles";
import { setRedirectUrl } from "api";
import styled from "styled-components";
import useLimitation from "hooks/useLimitation";
import BuyAddonPrompt from "components/global/BuyAddonPrompt";
import PlanIncrement from "components/global/PlanIncrement";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";
import useManageChannels from "hooks/useManageChannels";
import { PostContext } from "contexts/PostContext";

const plusGreyIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3C6.33137 3 6.6 3.26863 6.6 3.6V5.4L8.4 5.4C8.73137 5.4 9 5.66863 9 6C9 6.33137 8.73137 6.6 8.4 6.6H6.6V8.4C6.6 8.73137 6.33137 9 6 9C5.66863 9 5.4 8.73137 5.4 8.4V6.6H3.6C3.26863 6.6 3 6.33137 3 6C3 5.66863 3.26863 5.4 3.6 5.4H5.4V3.6C5.4 3.26863 5.66863 3 6 3Z"
      fill="#9A9AAF"
    />
  </svg>
);

const plusGreyIconLarge = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon">
      <path
        id="Icon_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 5C10.5523 5 11 5.44772 11 6V9L14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11H11V14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14V11H6C5.44772 11 5 10.5523 5 10C5 9.44771 5.44772 9 6 9L9 9V6C9 5.44772 9.44771 5 10 5Z"
        fill="#9A9AAF"
      />
    </g>
  </svg>
);

export const borderColor = {
  facebook: "#0866FF",
  instagram: "#FE0077",
  twitter: "#000000",
  linkedin: "#0A66C2",
  youtube: "#FF0000",
  tiktok: "#000000",
  meta_threads: "#000000",
  pinterest: "#E60023",
};

export const SelectedStyle = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) => `2px solid ${props.color}`};
  border-radius: 50%;

  img {
    width: 32px;
    height: 32px;
  }
`;

const Platform = ({ selected, channel, handleSelect }) => {
  const { platform, page } = channel || {};

  const handleSelectChannel = () => {
    handleSelect(platform);
  };

  return (
    <div className="flexRow platformWrapper alignCenter">
      <button className="platformBtn circle" onClick={handleSelectChannel}>
        {selected ? (
          <SelectedStyle className="circle" color={borderColor[platform]}>
            <img src={page?.photo || userIcon} alt="avi" className="circle" />
          </SelectedStyle>
        ) : (
          <PlatformPhoto border>
            <img
              src={socialIcons.circle[platform]}
              alt="icon"
              className="platformImg"
            />
          </PlatformPhoto>
        )}
      </button>
      {/* {selected && platformCheckIcon} */}
    </div>
  );
};

const SelectSocialMedia = ({
  brand,
  hasTitle,
  active_account,
  allowedPlatforms,
  noBrand,
  allChannels: allChannelsProp,
}) => {
  const {
    allChannels: allChannelsList,
    setSelectedChannels,
    platformMedia,
    platformList,
    handleUpdateMedia,
    parseEditorContent,
    setEditorState,
    contentByPlatform,
    contentByPlatformDispatch,
    setThreadFieldValue,
  } = useContext(PostContext);

  const allChannels = allChannelsProp ?? allChannelsList;
  const tempSupportedPlatforms = allowedPlatforms ?? supportedPlatforms;
  const { handleConnectPlatform, connecting } = useManageChannels(brand?.id);
  const { canAddMoreBrands, canPlusBrand, privileges } =
    useLimitation(active_account);
  const history = useHistory();
  const { postId, draftId } = useParams();
  const location = useLocation();
  const notConnected = tempSupportedPlatforms?.filter(
    (platform) => !allChannels?.find((channel) => channel.platform === platform)
  );
  const showNotSelected = !!postId || !!draftId;
  const [displayUpgradeModal, setDisplayUpgradeModal] = useState(false);
  const [connectSocialsUpgradeModal, setConnectSocialsUpgradeModal] =
    useState(false);
  const [selectSocialsUpgradeModal, setSelectSocialsUpgradeModal] =
    useState(false);
  const [incrementBrand, setIncrementBrand] = useState(false);
  const [showIncrementBrandPrompt, setShowIncrementBrandPrompt] =
    useState(false);

  const handleSelectPlatform = (platform) => {
    if (!privileges?.connectable_channels?.includes(platform)) {
      setSelectSocialsUpgradeModal(true);
      return;
    }

    setSelectedChannels((prev) => {
      if (platformList.includes(platform)) {
        return prev.filter((channel) => channel.platform !== platform);
      }

      const newSelected = allChannels.find(
        (channel) => channel.platform === platform
      );
      return [...prev, newSelected];
    });
    handleSelectActivePlatform(platform);
  };

  const handleSelectActivePlatform = useCallback(
    (platform) => {
      const defaultContent = contentByPlatform.default;
      const platformContent = contentByPlatform[platform];
      const platformMediaList = platformMedia[platform];

      if (
        platform === "twitter" &&
        !platformContent.thread?.[0]?.content &&
        !platformMediaList?.[0]?.length
      ) {
        setThreadFieldValue?.(0, "content", defaultContent.caption);
        handleUpdateMedia(platform, [platformMedia["default"]]);
      } else if (!platformContent.caption && !platformMediaList?.length) {
        const firstPlatform = platformList[0];
        if (firstPlatform && firstPlatform !== platform) {
          const caption =
            firstPlatform === "twitter"
              ? contentByPlatform.twitter.thread[0].content
              : contentByPlatform[firstPlatform].caption;

          const media =
            firstPlatform === "twitter"
              ? platformMedia.twitter[0]
              : platformMedia.default;

          contentByPlatformDispatch({
            platform,
            payload: {
              ...contentByPlatform[platform],
              caption,
            },
          });
          setEditorState(parseEditorContent(caption));
          handleUpdateMedia(platform, media);
        } else {
          contentByPlatformDispatch({
            platform,
            payload: {
              ...contentByPlatform[platform],
              caption: defaultContent.caption,
            },
          });
          setEditorState(parseEditorContent(defaultContent.caption));
          handleUpdateMedia(platform, platformMedia.default);
        }
      }
    },
    [
      contentByPlatform,
      platformMedia,
      setThreadFieldValue,
      handleUpdateMedia,
      platformList,
      contentByPlatformDispatch,
      setEditorState,
      parseEditorContent,
    ]
  );

  const handleConnect = (platform) => {
    let classname;

    if (
      location.pathname ===
      "/dashboard/posts/calendar-view?post_action=create_post"
    ) {
      if (["tiktok", "facebook", "instagram"].includes(platform)) {
        if (platform === "tiktok") {
          classname = "connectTiktokInfo";
        } else if (platform === "facebook") {
          classname = "connectFacebookInfo";
        } else if (platform === "instagram") {
          classname = "ConnectToIgPrompt";
        }
        document.querySelector(`.${classname}`).classList.add("show");
      } else if (!["tiktok", "facebook", "instagram"].includes(platform)) {
        handleConnectPlatform(platform);
      }
    } else {
      history.push(`/dashboard/brands/${brand?.id}/channels`);
    }
    setRedirectUrl(window.location.pathname);
  };

  return (
    <div>
      <UpgradeModal collection="brands" />
      <AddBrandModal />
      <BuyAddonPrompt
        showModal={showIncrementBrandPrompt}
        cancelBtnFn={() => setShowIncrementBrandPrompt(false)}
        actionBtnFn={() => {
          setIncrementBrand(true);
          setShowIncrementBrandPrompt(false);
        }}
        title="Brand slots exhausted"
        actionBtnText="Add slot"
        renderDescription={() => (
          <>
            {active_account?.current_subscription?.plan_id === 4 ? (
              <>
                You've reached the limit of available brand slots. You can
                purchase additional brand slots to add more brands.
              </>
            ) : (
              <>
                You've reached the limit of available brand slots. You can
                purchase additional brand slots or{" "}
                <Link to="/dashboard/plans">upgrade</Link> your account to a
                higher plan with more brand slots.
              </>
            )}
          </>
        )}
      />
      <PlanIncrement
        open={incrementBrand}
        close={() => setIncrementBrand(false)}
        type="brand"
        title="Purchase additional brand slot"
        description="Add a new brand slot to your workspace to manage more social media accounts"
      />
      {hasTitle && <p className="l3">Select social media channels</p>}
      <Spacer y={1.2} />
      <Socials className="channels-tour">
        {allChannels?.map((channel) => {
          const { platform, page } = channel;

          const components = {
            facebook: (
              <Platform
                key={platform}
                selected={platformList.includes("facebook")}
                channel={channel}
                handleSelect={handleSelectPlatform}
              />
            ),
            instagram: (
              <Platform
                key={platform}
                selected={platformList.includes("instagram")}
                channel={channel}
                handleSelect={handleSelectPlatform}
              />
            ),
            linkedin: (
              <Platform
                key={platform}
                selected={platformList.includes("linkedin")}
                channel={channel}
                handleSelect={handleSelectPlatform}
              />
            ),
            twitter: (
              <Platform
                key={platform}
                selected={platformList.includes("twitter")}
                channel={channel}
                handleSelect={handleSelectPlatform}
              />
            ),
            youtube: (
              <Platform
                key={platform}
                selected={platformList.includes("youtube")}
                channel={channel}
                handleSelect={handleSelectPlatform}
              />
            ),
            tiktok: (
              <Platform
                key={platform}
                selected={platformList.includes("tiktok")}
                channel={channel}
                handleSelect={handleSelectPlatform}
              />
            ),
            pinterest: (
              <Platform
                key={platform}
                selected={platformList.includes("pinterest")}
                channel={channel}
                handleSelect={handleSelectPlatform}
              />
            ),
            meta_threads: (
              <Platform
                key={platform}
                selected={platformList.includes("meta_threads")}
                channel={channel}
                handleSelect={handleSelectPlatform}
              />
            ),
          };

          return page ? components[platform] : null;
        })}
        {/* {!showNotSelected && (
          <>
            {notConnected.map((platform) => (
              <button
                key={platform}
                className="not-connected"
                onClick={() => {
                  privileges?.connectable_channels?.includes(platform)
                    ? handleConnect(platform)
                    : setConnectSocialsUpgradeModal(true);
                }}
                disabled={connecting}
              >
                <img src={socialIcons.grey[platform]} alt="icon" />
                {plusGreyIcon}
              </button>
            ))}
          </>
        )} */}
        {/* the checks is done differently so styling is not affected */}
        {/* {!showNotSelected && !noBrand && (
          <>
            <button
              className="flexRow alignCenter justifyCenter not-connected add-brand"
              onClick={() => {
                if (!canAddMoreBrands) {
                  if (canPlusBrand) {
                    setShowIncrementBrandPrompt(true);
                  } else {
                    setDisplayUpgradeModal(true);
                  }
                } else {
                  toggleModalVisibility("#addBrandModal");
                }
              }}
            >
              {plusGreyIconLarge}
            </button>
          </>
        )} */}
      </Socials>

      <UpgradeModal
        modalTitle={"Upgrade your account "}
        modalDescription={
          "You have reached the maximum number of brands for this plan. Upgrade your plan to add more brands."
        }
        handleCancel={() => setDisplayUpgradeModal(false)}
        cover={false}
        showModal={displayUpgradeModal}
      />
      <UpgradeModal
        modalTitle={"Upgrade your account "}
        modalDescription={
          "Your plan only supports Instagram, Facebook and LinkedIn. Upgrade your plan to connect more channels."
        }
        handleCancel={() => setConnectSocialsUpgradeModal(false)}
        cover={false}
        showModal={connectSocialsUpgradeModal}
      />
      <UpgradeModal
        modalTitle={"Upgrade your account "}
        modalDescription={
          "Your plan only supports Instagram, Facebook and LinkedIn. Upgrade your plan to post to this channel."
        }
        handleCancel={() => setSelectSocialsUpgradeModal(false)}
        cover={false}
        showModal={selectSocialsUpgradeModal}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    brand: state.brand,
    active_account: state.active_account,
  };
};

export default connect(mapStateToProps)(SelectSocialMedia);
